import React from 'react'
import { Select, Form, Image } from 'antd';
import { GLOBAL_CONSTANTS } from '../../constants/constants';
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg";

const { Option } = Select;

const CountryCode = ({ disabled }) => {
    return (
        <Form.Item name="countryCode" noStyle>
            <Select
                style={{ width: 80 }}
                disabled={disabled}
                suffixIcon={<Image src={ArrowDownIcon} alt='Arrow Down' preview={false} />}
            >
                <Option value="91">{GLOBAL_CONSTANTS.COUNTRY_CODE}</Option>
            </Select>
        </Form.Item>
    )
}

export default CountryCode